/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};
//
exports.getVendorList = function (data, callback) {// 获取供应商列表
    api.post('/vendor/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getMerchantDtoPageList = function (data, callback) {// 获取供应商列表
    api.post('/vendor/merchant/dto/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getMerchantDtoListByIds = function (data, callback) {// 获取供应商列表
    api.post('/vendor/merchant/dto/list/get/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getMerchantDto = function (data, callback) {// 获取供应商列表
    api.post('/vendor/merchant/dto/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/vendor.js
// module id = 104
// module chunks = 1